import { AUSTRALIA_COUNTRY_CODE, ISRAEL_COUNTRY_CODE, NORWAY_COUNTRY_CODE } from '../countryCodes.constants';

export const REGULATED_COUNTRY_CODES = [ISRAEL_COUNTRY_CODE, NORWAY_COUNTRY_CODE, AUSTRALIA_COUNTRY_CODE] as const;

export interface RegulatedCountry {
    regions?: string[];
}

type RegulationConfig = {
    [key in (typeof REGULATED_COUNTRY_CODES)[number]]: RegulatedCountry;
};

export const REGULATION_CONFIG: RegulationConfig = {
    [ISRAEL_COUNTRY_CODE]: {},
    [NORWAY_COUNTRY_CODE]: {},
    [AUSTRALIA_COUNTRY_CODE]: {},
} as const;
